import { PropsWithChildren } from 'react';
import { SegmentHandler, useTrackLinks, useTrackPage } from '@repo/segment';
import { useLocation, useRouteContext } from '@tanstack/react-router';
import { useAmplitudeInit } from '@repo/amplitude/client';
import { AMPLITUDE_ENVIRONMENT } from '~/config/env';
import styles from './AppLayout.module.css';

SegmentHandler.instance.init(import.meta.env.VITE_APP_SEGMENT_WRITE_KEY!);

export const AppLayout = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const { isImpersonating } = useRouteContext({ from: '__root__' });
  // Guides & Surveys stay out of impersonated sessions.
  useAmplitudeInit(AMPLITUDE_ENVIRONMENT, {
    skipEngagement: !!isImpersonating,
  });
  useTrackLinks();
  useTrackPage([location.pathname]);
  return (
    <>
      <div className={styles.appWrapper}>
        <div className={styles.pageWrapper}>{children}</div>
      </div>
    </>
  );
};

export default AppLayout;
